export interface AdContent {
    title: string;
    description: string;
    backgroundGradient: string;
}

export const adContents: AdContent[] = [
    {
        title: "이도도자기",
        description: "1990년에 탄생한 이도도자기는 국내 장인의 손으로만 빚는 진짜 수공예 도자기입니다.",
        backgroundGradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
        title: "여주 3,000평 규모의 공장",
        description: "이도도자기는 여주에 위치한 3,000평 규모의 대규모 자체 공장을 보유하고 있습니다. 도자기의 시작부터 완성까지 한 곳에서 이루어집니다.",
        backgroundGradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
    },
    {
        title: "이도 청담",
        description: "이도도자기가 운영하는 컨템포러리 이탈리안 레스토랑. 모든 음식이 이도의 식기와 테이블웨어에 담겨 나오며, 화장실과 인테리어까지 도자기로 이루어진 특별한 공간입니다. 최근 블루리본도 수상했습니다.",
        backgroundGradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
    },
    {
        title: "이도 커스텀 타일",
        description: "축적된 세라믹 기술을 바탕으로 공간에 맞는 독특한 타일을 제안합니다. 색상과 형태까지 완전한 커스텀이 가능해 해외 명품 매장에서도 사랑받는 브랜드입니다.",
        backgroundGradient: "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)"
    },
    {
        title: "이도 오디너리",
        description: "이도 오디너리는 아티스트와 협업해 다양한 예술 오브제를 선보이는 콜라보레이션 브랜드입니다. 도자기와 예술이 만나는 감각적인 프로젝트를 경험해보세요.",
        backgroundGradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    {
        title: "수공예의 힘",
        description: "모든 제품에는 장인의 손길과 이도의 낙관이 새겨집니다. 세상에 단 하나뿐인 온기를 담은 수공예 도자기.",
        backgroundGradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)"
    },
    {
        title: "순 라인",
        description: "‘순’ 라인은 이도도자기의 특별한 기법으로 만들어진 부드럽고 따뜻한 질감이 특징입니다. 손끝에서 느껴지는 감촉까지 디자인한 도자기.",
        backgroundGradient: "linear-gradient(135deg, #9be15d 0%, #00e3ae 100%)"
    },
    {
        title: "달항아리",
        description: "이도도자기의 달항아리는 부담스럽지 않은 가격으로 누구나 고급스러운 달항아리를 쉽게 만날 수 있도록 만들어졌습니다.",
        backgroundGradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
    }
];

export const getRandomAd = (): AdContent => {
    const randomIndex = Math.floor(Math.random() * adContents.length);
    return adContents[randomIndex];
};
